import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
import styled, { css } from 'styled-components';

export const commonInfoBoxPadding = css`
  padding: 8px;
`;

export const commonInfoBoxBorder = css`
  border: 1px solid ${themeGet('colors.border.default')};
  border-radius: 2px;
`;

export const commonOverlaySmallShadow = css`
  box-shadow: 0 2px 0 rgba(27, 31, 36, 0.04); // Todo RN: add global variables for different box shadows etc into a sensible place
`;

export const InsightOrTargetQuote = styled.div`
  ${commonInfoBoxPadding};
  padding-top: 0;
  flex-grow: 1;
  text-align: left;
`;
